import { APPS_AND_WEBSITES_BREADCRUMB } from 'modules/mobileApps/constants';
import { AppPlatform } from 'modules/mobileApps/types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { HeaderTitle, SecondaryPageHeader } from 'ui/pageHeader';
import { createMobileApp } from '../../actions';
import { ConfigureAppForm } from './ConfigureAppForm';

export const CreateApp = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [platform, setPlatform] = useState<AppPlatform>();
  const [packageName, setPackageName] = useState('');
  const [storeUrl, setStoreUrl] = useState('');

  const handleSubmit = () =>
    dispatch(
      createMobileApp({
        name,
        platform,
        packageName,
        storeUrl,
      }),
    );

  return (
    <>
      <SecondaryPageHeader breadcrumb={APPS_AND_WEBSITES_BREADCRUMB}>
        <HeaderTitle>New app or website</HeaderTitle>
      </SecondaryPageHeader>
      <ConfigureAppForm
        handleSubmit={handleSubmit}
        name={name}
        onNameChange={(newName) => setName(newName)}
        onPackageNameChange={(newPackageName) => setPackageName(newPackageName)}
        onPlatformChange={(newPlatform) => setPlatform(newPlatform)}
        onStoreUrlChange={(newStoreUrl) => setStoreUrl(newStoreUrl)}
        packageName={packageName}
        platform={platform}
        storeUrl={storeUrl}
        submitButtonText="Create app"
      />
    </>
  );
};
